import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-[64px] right-0 w-full md:w-96 max-h-screen flex flex-col bg-card border-l border-border z-50 shadow-xl"
}
const _hoisted_2 = { class: "flex items-center justify-between p-4 border-b border-border" }
const _hoisted_3 = { class: "text-lg font-bold text-foreground flex items-center gap-2" }
const _hoisted_4 = { class: "flex-1 overflow-y-auto" }

import { computed } from 'vue';
import { useCartStore } from '@/stores/cartStore';
import { useToast } from '@/composables/useToast';
import CartEmpty from '@/components/cart/CartEmpty.vue';
import CartItemRow from '@/components/cart/CartItemRow.vue';
import CartSummary from '@/components/cart/CartSummary.vue';
import CartActions from '@/components/cart/CartActions.vue';
import type { IProductRequest } from '@/data/_autogen/IValveVista';

interface Props {
  isOpen: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ShoppingCartFloating',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const cartStore = useCartStore();
const { error } = useToast();

const getProductDetails = (productId: number): IProductRequest => {
  return (
    cartStore.getProductById(productId) || {
      id: productId,
      displayName: 'Unknown Product',
      price: 0,
    }
  );
};

const handleClose = () => {
  emit('close');
};

const handleBackdropClick = () => {
  emit('close');
};

const handleDeleteItem = async (productId: number) => {
  try {
    await cartStore.removeItem(productId);
  } catch (err) {
    error('Failed to remove item from cart');
    console.error('Delete item error:', err);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-black/30 z-40",
              onClick: handleBackdropClick
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h2", _hoisted_3, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fal', 'shopping-cart'],
                    class: "text-primary"
                  }),
                  _cache[0] || (_cache[0] = _createTextVNode(" Shopping Cart ", -1))
                ]),
                _createElementVNode("button", {
                  class: "p-2 text-muted-foreground hover:text-foreground transition-colors rounded-lg hover:bg-primary/10",
                  "aria-label": "Close cart",
                  onClick: handleClose
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fal', 'times'],
                    class: "text-lg"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_unref(cartStore).isEmpty)
                  ? (_openBlock(), _createBlock(CartEmpty, { key: 0 }))
                  : (_openBlock(), _createBlock(_TransitionGroup, {
                      key: 1,
                      name: "list",
                      tag: "div",
                      class: "divide-y divide-border"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).cartItems, (item) => {
                          return (_openBlock(), _createBlock(CartItemRow, {
                            key: item.productId,
                            item: item,
                            product: getProductDetails(item.productId!),
                            onDelete: handleDeleteItem
                          }, null, 8, ["item", "product"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
              ]),
              (!_unref(cartStore).isEmpty)
                ? (_openBlock(), _createBlock(CartSummary, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(CartActions, { onClose: handleClose })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})